import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

import App from 'App';

import { formatFigure } from 'Helpers/formatService';

export default function GeneralRisk(props) {
    const [isLoading, setIsLoading] = useState(true);
    const [risk, setRisk] = useState(null);

    useEffect(() => {
        fetchDataset();
    }, []);

    const fetchDataset = () => {
        setIsLoading(true);
        axios
            .get(fetchGeneralRiskUrl)
            .then(({ data }) => {
                setRisk(data);
            })
            .catch((e) => {
                console.error(e);
            })
            .finally(() => setIsLoading(false));
    };
    if (isLoading) {
        return <Loading />;
    } else if (!risk) {
        return <div className="text-danger">{$t('Something went wrong')}.</div>;
    }

    return (
        <div>
            <div className="card bg-white border-0 rounded-15px shadow my-4">
                <div className="card-body">
                    <h5 className="card-title">{$t('General Risk')}</h5>
                    <div className="row">
                        <div className="col-6">
                            <table className="table table-borderless no-footer">
                                <tbody>
                                    <tr>
                                        <td style={{ width: '30%' }} className="p-0">
                                            {$t('Description')}
                                        </td>
                                        <td className="text-primary font-weight-bold p-1">{risk.description}</td>
                                    </tr>
                                    <tr>
                                        <td style={{ width: '30%' }} className="p-0">
                                            {$t('Detailed description')}
                                        </td>
                                        <td className="text-primary font-weight-bold p-1">{risk.detailed_description}</td>
                                    </tr>
                                    <tr>
                                        <td style={{ width: '30%' }} className="p-0">
                                            {$t('Owner')}
                                        </td>
                                        <td className="text-primary font-weight-bold p-1">
                                            {risk.owner?.first_name} {risk.owner?.last_name}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ width: '30%' }} className="p-0">
                                            {$t('Mitigation')}
                                        </td>
                                        <td className="text-primary font-weight-bold p-1">{risk.mitigation}</td>
                                    </tr>
                                    <tr>
                                        <td style={{ width: '30%' }} className="p-0">
                                            {$t('Status')}
                                        </td>
                                        <td className="text-primary font-weight-bold p-1">{risk.status?.title}</td>
                                    </tr>
                                    <tr>
                                        <td style={{ width: '30%' }} className="p-0">
                                            {$t('Type')}
                                        </td>
                                        <td className="text-primary font-weight-bold p-1">{risk.type?.title}</td>
                                    </tr>
                                    <tr>
                                        <td style={{ width: '30%' }} className="p-0">
                                            {$t('Budget Impact')}
                                        </td>
                                        <td className="text-primary font-weight-bold p-1">{risk.budget_impact ? 'Yes' : 'No'}</td>
                                    </tr>
                                    <tr>
                                        <td style={{ width: '30%' }} className="p-0">
                                            {$t('AFC')}
                                        </td>
                                        <td className="text-primary font-weight-bold p-1">
                                            {risk.expense_id || risk.revenue_id || risk.sponsor_id || risk.ticketing_id ? 'Yes' : 'No'}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ width: '30%' }} className="p-0">
                                            {$t('Value')}
                                        </td>
                                        <td className="text-primary font-weight-bold p-1">{formatFigure(risk.amount)}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div className="col-6">
                            <table className="table table-borderless no-footer">
                                <tbody>
                                    <tr>
                                        <td style={{ width: '30%' }} className="p-0">
                                            {$t('Impact')}
                                        </td>
                                        <td className="text-primary font-weight-bold p-1">{risk.impact?.mark}</td>
                                    </tr>
                                    <tr>
                                        <td style={{ width: '30%' }} className="p-0">
                                            {$t('Probability')}
                                        </td>
                                        <td className="text-primary font-weight-bold p-1">{risk.probability?.mark}</td>
                                    </tr>
                                    <tr>
                                        <td style={{ width: '30%' }} className="p-0">
                                            {$t('Priority (RAG)')}
                                        </td>
                                        <td className="text-primary font-weight-bold p-1">
                                            <div style={{ height: 20, width: 100, backgroundColor: risk.classification_color }}></div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ width: '30%' }} className="p-0">
                                            {$t('Controlled Impact')}
                                        </td>
                                        <td className="text-primary font-weight-bold p-1">{risk.controlled_impact?.mark}</td>
                                    </tr>
                                    <tr>
                                        <td style={{ width: '30%' }} className="p-0">
                                            {$t('Controlled Probability')}
                                        </td>
                                        <td className="text-primary font-weight-bold p-1">{risk.controlled_probability?.mark}</td>
                                    </tr>
                                    <tr>
                                        <td style={{ width: '30%' }} className="p-0">
                                            {$t('Residual Priority')}
                                        </td>
                                        <td className="text-primary font-weight-bold p-1">
                                            <div style={{ height: 20, width: 100, backgroundColor: risk.residual_classification_color }}></div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <div className="card bg-white border-0 rounded-15px shadow my-4">
                <div className="card-body">
                    <h5 className="card-title">{$t('Inter-dependencies')}</h5>
                    {!risk.issues?.length && !risk.decisions?.length ? (
                        <div>{$t('No Inter-dependencies')}</div>
                    ) : (
                        <table className="table table-sm table-bordered no-footer text-center m-0">
                            <thead>
                                <tr className="text-center font-weight-bold text-blue table__label_text">
                                    <th style={{ width: '10%' }}>{$t('Unique Reference')}</th>
                                    <th style={{ minWidth: '200px' }}>{$t('Description')}</th>
                                    <th>{$t('Type')}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {risk.issues.map((issue) => (
                                    <InterDependencyRow
                                        row={issue}
                                        link={fetchGeneralIssueUrl.replace('GENERAL_ISSUE_ID', issue.id)}
                                        key={issue.id}
                                        type={$t('General Issue')}
                                    />
                                ))}
                                {risk.decisions.map((decision) => (
                                    <InterDependencyRow
                                        row={decision}
                                        link={fetchGeneralDecisionUrl.replace('GENERAL_DECISION_ID', decision.id)}
                                        key={decision.id}
                                        type={$t('General Decision')}
                                    />
                                ))}
                            </tbody>
                        </table>
                    )}
                </div>
            </div>
        </div>
    );
}

function Loading() {
    return (
        <div className="row my-2">
            <div className="col-12 d-flex align-items-center justify-content-center text-blue">
                <div
                    className="spinner-border"
                    style={{
                        width: '2rem',
                        height: '2rem',
                    }}
                    role="status"
                >
                    <span className="sr-only">{$t('Loading')}...</span>
                </div>
            </div>
        </div>
    );
}

function InterDependencyRow({ row, link, type }) {
    return (
        <tr>
            <td>{row.id}</td>
            <td className="text-left">
                <a href={link}>{row.description}</a>
            </td>
            <td>{type}</td>
        </tr>
    );
}

if (document.getElementById('generalRiskShow')) {
    var root = document.getElementById('generalRiskShow');
    ReactDOM.render(
        <App>
            <GeneralRisk />
        </App>,
        root,
    );
}
